document.addEventListener("DOMContentLoaded", function () {
    const officeItem = document.querySelector('.hover__zoom-clear.office');
    const hotelItem = document.querySelector('.hover__zoom-clear.hotel');
    const residentialItem = document.querySelector('.hover__zoom-clear.residential');
    const healthcareItem = document.querySelector('.hover__zoom-clear.healthcare');
    const commercialItem = document.querySelector('.hover__zoom-clear.commercial');
    const otherItem = document.querySelector('.hover__zoom-clear.other');

    const officeElement = document.getElementById('office');
    const hotelElement = document.getElementById('hotel');
    const residentialElement = document.getElementById('residential');
    const healthcareElement = document.getElementById('healthcare');
    const commercialElement = document.getElementById('commercial');
    const otherElement = document.getElementById('other');

    var splide1 = new Splide('#splide-imgs1', {
        // type: 'loop',
        perPage: 1,
        rewind: true,
    }).mount();

    var splide2 = new Splide('#splide-imgs2', {
        // type: 'loop',
        perPage: 1,
        rewind: true,
    }).mount();

    var splide3 = new Splide('#splide-imgs3', {
        // type: 'loop',
        perPage: 1,
        rewind: true,
    }).mount();


    officeItem.addEventListener('click', function () {
        officeElement.classList.add('is-active');
        // splide1.go(1);
        // splide1.go(0);
    });

    residentialItem.addEventListener('click', function () {
        residentialElement.classList.add('is-active');
        // splide2.go(1);
        // splide2.go(0);
    });

    otherItem.addEventListener('click', function () {
        otherElement.classList.add('is-active');
        // splide3.go(1);
        // splide3.go(0);
    });

    hotelItem.addEventListener('click', function () {
        hotelElement.classList.add('is-active');
    });

    healthcareItem.addEventListener('click', function () {
        healthcareElement.classList.add('is-active');
    });

    commercialItem.addEventListener('click', function () {
        commercialElement.classList.add('is-active');
    });

    // Closeボタンのクリックイベントを設定
    document.body.addEventListener('click', function (e) {
        if (e.target.classList.contains('popup__box-close')) {
            const section = e.target.closest('.assetsundermanagement__imgs');
            if (section) {
                section.classList.remove('is-active');
            }
        }
    });
});
